var React = require('react');

function ScheduleBlack24dp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z","key":1}),React.createElement("path",{"d":"M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z","key":2})]);
}

ScheduleBlack24dp.defaultProps = {"height":"24px","viewBox":"0 0 24 24","width":"24px","fill":"#000000"};

module.exports = ScheduleBlack24dp;

ScheduleBlack24dp.default = ScheduleBlack24dp;
